

























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import _ from "lodash";
import Util from "../../../lib/util";

class CreateSessionPrintCollectionCodeDto {
  type: string;
  qty: number = 1;
  note: string = "";
}
@Component
export default class CreateSessionPrintCollectionCode extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;
  sessionPrintCollectionCode: CreateSessionPrintCollectionCodeDto = new CreateSessionPrintCollectionCodeDto();
  spinShow: boolean = false;
  namespace = "sessionPrintCollectionCode";

  types = [];
  get store() {
    return this.$store.state.collectionCode;
  }
  async getTypes() {
    await this.$store
      .dispatch({
        type: `collectionCode/getTypesForSelect`,
      })
      .then(() => {
        var re = this.store.types;
        this.types = re;
      });
  }
  save() {
    (this.$refs.createSessionPrintCollectionCodeForm as any).validate(
      async (valid: boolean) => {
        if (valid) {
          this.spinShow = true;
          this.$store
            .dispatch({
              type: `${this.namespace}/create`,
              data: this.sessionPrintCollectionCode,
            })
            .then(() => {
              Util.showSuccessMsg(
                this,
                "Success.CreateSessionPrintCollectionCode"
              );
              (this.$refs
                .createSessionPrintCollectionCodeForm as any).resetFields();
              this.$emit("save-success");
              this.$emit("input", false);
            })
            .finally(() => {
              this.spinShow = false;
            });
        }
      }
    );
  }
  cancel() {
    this.sessionPrintCollectionCode = new CreateSessionPrintCollectionCodeDto();
    (this.$refs.createSessionPrintCollectionCodeForm as any).resetFields();
    this.$emit("input", false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
    }
  }
  created() {
    this.getTypes();
  }
  sessionPrintCollectionCodeRules = {
    type: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Type")),
        trigger: "blur",
      },
    ],
  };
}
